import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Paper from 'material-ui/Paper'
import FlatButton from 'material-ui/FlatButton'
import PlacePopularContainer from '../../Place/PlacePopularContainer'
import FoodPopularContainer from '../../Food/FoodPopularContainer'
import OtopPopularContainer from '../../Otop/OtopPopularContainer'
import NewsPopularContainer from '../../News/NewsPopularContainer'
import HotelsPopularContainer from '../../Hotels/HotelsPopularContainer'
import ShoppingPopularContainer from '../../Shopping/ShoppingPopularContainer'
import { askForPermissioToReceiveNotifications } from '../../../push-notification'

class Popular extends Component {
  renderContent() {
    if (this.props.lang === 'th') {
      return (
        <div>
          <h3>สำนักงานการท่องเที่ยวและกีฬาจังหวัดพระนครศรีอยุธยา</h3>
          <p>157 สนามกีฬากลางจังหวัดพระนครศรีอยุธยา ต.ไผ่ลิง อ.พระนครศรีอยุธยา จ.พระนครศรีอยุธยา 13000
          <br />โทรศัพท์. 035-902719 โทรสาร. 035-902720</p>
        </div>
      );
    } else if (this.props.lang === 'zh') {
      return (
        <div>
          <h3>大城府，旅游及运动办公室</h3>
          <p>157号，大城府中央运动场，Pailing 乡，大城县，大城府
          <br />电话：0 3590 2719 ，传真：0 3590 2720</p>
        </div>
      );
    } else {
      return (
        <div>
          <h3>Office of Tourism and Sport of Ayutthaya Province</h3>
          <p>157 Ayutthaya Central Stadium, Phai Ling Sub-district, Phranakhon Si Ayutthaya District, Ayutthaya Province 13000
          <br />Telephone: +66-3590-2719; Fax: +66-3590-2720</p>
        </div>
      );
    }
  }

  render() {
    return (
      <div style={{ width: '100%' }}>
        {/* <FlatButton label="Click here to receive notifications" fullWidth={true} onClick={askForPermissioToReceiveNotifications} /> */}
        <NewsPopularContainer />
        <PlacePopularContainer />
        <FoodPopularContainer />
        <OtopPopularContainer />
        <HotelsPopularContainer />
        <ShoppingPopularContainer />
        <Paper zDepth={1} style={{
          padding: 10,
          marginTop: 10,
          paddingTop: 1
        }}>
          { this.renderContent() }
        </Paper>
      </div>
    )
  }
}

const mapStateToProps = ({ lang, ...state }) => ({
  lang
})
export default connect(mapStateToProps)(Popular)


// WEBPACK FOOTER //
// ./src/containers/Home/Popular/Popular.js